
export function escapeHtml(unsafe:string|null|undefined):string {
    if (unsafe == null) return "";
    return unsafe.replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
}

export class SafeHtml {
    private html: string;
    constructor(html?:string|SafeHtml) {
        this.html = html === undefined ? "" : html.toString();
    }

    toString() {
        return this.html;
    }

    append(str:any):SafeHtml {
        if (str != null) {
            if (str instanceof SafeHtml) this.html += str.html;
            else this.html += escapeHtml(str.toString());
        }
        return this;
    }

    appendHtml(str:string):SafeHtml {
        if (str != null) this.html += str;
        return this;
    }

    toJSON(_:any) {
        return this.html;
    }

    static join(separator: string, ...str:any[]):SafeHtml {
        const html = new SafeHtml("");
        let i = 0;
        for (let s of str) {
            html.append(s);
            if (i > 0 && separator != null && separator.length > 0) html.appendHtml(separator);
            i++;
        }
        return html;
    }
}
